import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import SuccessIcon from '../assets/images/circle-check-regular'

const Success = (props) => {
    const { } = props;
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        setTimeout(() => setLoading(false), 3000)
    }, []);

    return (
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '70px 0', gap: '40px', textAlign: 'center'}}>
            {loading ?
                <div style={{fontSize: '30px'}}>{t('sending-data')}</div> :
                <>
                    <SuccessIcon height={100}/>
                    <div style={{fontSize: '30px'}}>{t('success-submit')}</div>
                </>}
        </div>
    );
};

export default Success;